import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {getUrlParameters} from '../../common/util/urlParameters';
import {getPartsReturnDetail} from './returnOrders';

export const getClaimSaleData = (info) => {
  const searchFilters = getUrlParameters(info);

  return apiActionCreator({
    'endpoint': `/parts/returns/invoice-items${searchFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.GET_SALE_RETURN_DATA_REQUEST,
      ActionTypes.GET_SALE_RETURN_DATA_SUCCESS,
      ActionTypes.GET_SALE_RETURN_DATA_FAILED,
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const processReturnOrderClaim = (returnCode, claim) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/parts/returns/${returnCode}`,
      'authenticated': true,
      'types': [
        ActionTypes.PROCESS_RETURN_CLAIM_REQUEST,
        () => {
          dispatch(getPartsReturnDetail(returnCode));
          return {'type': ActionTypes.PROCESS_RETURN_CLAIM_SUCCESS};
        },
        ActionTypes.PROCESS_RETURN_CLAIM_FAILED,
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': claim,
    }),
  );
};

export const addNewReturnClaimAttachment = (claimCode, data) => apiActionCreator({
  'endpoint': `/parts/returns/attachments/${claimCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.ADD_RETURN_CLAIM_ATTACHMENT_REQUEST,
    ActionTypes.ADD_RETURN_CLAIM_ATTACHMENT_SUCCESS,
    ActionTypes.ADD_RETURN_CLAIM_ATTACHMENT_FAILED,
  ],
  'microservice': 'part',
  'method': 'POST',
  'data': data,
});

export const removeReturnClaimAttachment = (claimCode, attachmentCode) => apiActionCreator({
  'endpoint': `/parts/returns/attachments/${claimCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.REMOVE_RETURN_CLAIM_ATTACHMENT_REQUEST,
    ActionTypes.REMOVE_RETURN_CLAIM_ATTACHMENT_SUCCESS,
    ActionTypes.REMOVE_RETURN_CLAIM_ATTACHMENT_FAILED,
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': {attachmentCode},
});

export const clearReturnOrderClaim = () => ({
  'type': ActionTypes.CLEAR_RETURN_CLAIM,
});

export const selectReturnOrderClaim = (claim) => ({
  'type': ActionTypes.SELECT_RETURN_CLAIM,
  'payload': claim,
});

export const editReturnClaimValue = (name, value) => ({
  'type': ActionTypes.EDIT_RETURN_CLAIM_VALUE,
  'payload': {name, value},
});

export const addNewReturnClaim = (claim, index) => ({
  'type': ActionTypes.SAVE_RETURN_CLAIM,
  'payload': {claim, index},
});
